import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/search-insights")({
  component: lazyRouteComponent(() => import("./-pages/admin.search-insights")),
  head: () => ({
    meta: [
      { title: "Search Insights · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
